import { useEffect, useMemo, useRef } from "react";

import { useWebApp } from "@/features/webapp";
import { useUserProfile } from "@/features/user";

import {
  buildSeries,
  parseBirthDate,
  todayBiorhythm,
} from "../../lib/biorhythm";
import { useAstroToday } from "../../hooks/use-astro-today";
import { BiorhythmChart } from "./biorhythm-chart";
import { BiorhythmForToday } from "./biorhythm-for-today";
import { BiorhythmCycles } from "./biorhythm-cycles";
import { YourRhythmDecoded } from "./your-rhythm-decoded";
import { BiorhythmCountdown } from "./biorhythm-countdown";
import { PersonalizedReports } from "../personalized-reports";

export function BiorhythmCategory() {
  const { removeMarker } = useWebApp();
  const isMarkerUpdatedRef = useRef(false);
  const { profile } = useUserProfile();
  const { meta } = useAstroToday(["biorhythms"]);

  useEffect(() => {
    const handleScroll = () => {
      if (isMarkerUpdatedRef.current) {
        return;
      }

      if (window.scrollY < 200) {
        return;
      }

      isMarkerUpdatedRef.current = true;
      removeMarker("biorhythm");
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [removeMarker]);

  const birth = useMemo(
    () =>
      parseBirthDate(
        typeof profile?.birthDate === "string" ? profile.birthDate : undefined,
      ),
    [profile],
  );

  const series = useMemo(() => (birth ? buildSeries(birth) : null), [birth]);
  const todayValues = useMemo(
    () => (birth ? todayBiorhythm(birth) : null),
    [birth],
  );

  return (
    <div className="w-full">
      <BiorhythmChart series={series} />
      <BiorhythmForToday values={todayValues} />
      <BiorhythmCycles />
      <YourRhythmDecoded />

      <PersonalizedReports />
      <BiorhythmCountdown targetDate={meta?.next_sync} />
    </div>
  );
}
